function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  id: "Oval",
  cx: 30,
  cy: 30,
  fill: "#cad9fc",
  r: 29
}), React.createElement("circle", {
  cx: 16,
  cy: 20,
  fill: "#a4c2f7",
  r: 3
}), React.createElement("circle", {
  cx: 36,
  cy: 20,
  fill: "#a4c2f7",
  r: 3
}), React.createElement("path", {
  d: "m48.95 8.05c-11.499-9.929-28.713-9.3-39.456 1.444-10.744 10.743-11.373 27.956-1.444 39.456 8.586 7.414 20.707 9.14 31.022 4.419 10.314-4.722 16.929-15.025 16.928-26.369.013-6.96-2.491-13.691-7.05-18.95z",
  fill: "#e8edfc"
}), React.createElement("path", {
  d: "m22 31h8c.552 0 1 .448 1 1v1c0 2.761-2.239 5-5 5s-5-2.239-5-5v-1c0-.552.448-1 1-1z",
  fill: "#a4c2f7"
}), React.createElement("path", {
  d: "m0 30c.015-4.5 1.036-8.94 2.989-12.994.606-1.265 1.295-2.489 2.062-3.664.398-.577.833-1.128 1.248-1.693.41-.569.86-1.108 1.347-1.613 1.858-2.106 4.014-3.93 6.399-5.414 2.372-1.506 4.948-2.662 7.65-3.434 2.705-.759 5.497-1.159 8.305-1.188v2c-2.621.029-5.227.402-7.751 1.111-2.521.72-4.924 1.799-7.137 3.204-2.227 1.384-4.24 3.087-5.974 5.054-.456.47-.877.973-1.258 1.505-.387.528-.795 1.041-1.167 1.579-.715 1.097-1.357 2.239-1.923 3.42-1.822 3.785-2.775 7.928-2.79 12.127z",
  fill: "#fff"
}), React.createElement("path", {
  d: "m3.955 30c0-15.523 12.197-28.197 27.53-28.963-.487-.024-.977-.037-1.47-.037-16.016 0-29 12.984-29 29s12.984 29 29 29c.493 0 .983-.013 1.47-.037-15.333-.766-27.53-13.44-27.53-28.963z",
  fill: "#fff"
}), React.createElement("g", {
  fill: "#428dff"
}, React.createElement("path", {
  d: "m1.456 25.027c-.265-.043-.536.024-.751.185s-.356.401-.39.668l-.155 1.022-.057 1.032-.103 2.066h2l.099-1.929.051-.964.147-.954c.065-.54-.305-1.036-.841-1.126z"
}), React.createElement("path", {
  d: "m30 2v-2c-2.808.029-5.6.429-8.304 1.189-2.702.772-5.278 1.928-7.65 3.434-2.385 1.483-4.541 3.307-6.399 5.414-.488.504-.938 1.043-1.347 1.612-.416.565-.851 1.116-1.248 1.693-.767 1.174-1.456 2.398-2.062 3.664l-.448.932c-.114.246-.122.528-.02.779.101.251.302.449.555.547.502.19 1.066-.036 1.296-.521l.419-.869c.565-1.181 1.207-2.323 1.923-3.42.372-.538.78-1.052 1.167-1.579.381-.533.801-1.036 1.257-1.505 1.734-1.967 3.746-3.67 5.974-5.054 2.213-1.405 4.616-2.485 7.137-3.204 2.523-.71 5.129-1.083 7.75-1.112z"
}), React.createElement("path", {
  d: "m1.154 21.832c-.065.264-.03.543.098.783l.115.156c.044.051.096.096.152.133.048.042.102.076.16.101.061.027.125.049.189.067.258.058.528.021.76-.105.11-.067.206-.154.283-.257.235-.317.259-.743.061-1.085-.065-.111-.148-.211-.248-.293-.098-.085-.212-.149-.335-.19-.257-.078-.534-.056-.774.064-.228.143-.393.366-.461.626z"
}), React.createElement("path", {
  d: "m30 60c-16.568-.002-29.998-13.432-30-30 0-.552.448-1 1-1s1 .448 1 1c.001 15.463 12.536 27.998 27.999 27.997 15.463 0 27.998-12.535 27.998-27.998.001-15.463-12.534-27.998-27.997-27.999-.552 0-1-.448-1-1s.448-1 1-1c16.569 0 30 13.431 30 30s-13.431 30-30 30z"
}), React.createElement("path", {
  d: "m16 24c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4c-.002 2.208-1.792 3.998-4 4zm0-6c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2c-.001-1.104-.896-1.999-2-2z"
}), React.createElement("path", {
  d: "m36 24c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4c-.002 2.208-1.792 3.998-4 4zm0-6c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2c-.001-1.104-.896-1.999-2-2z"
}), React.createElement("path", {
  d: "m26 39c-3.312-.004-5.996-2.688-6-6v-1c.001-1.104.896-1.999 2-2h8c1.104.001 1.999.896 2 2v1c-.004 3.312-2.688 5.996-6 6zm-4-7v1c0 2.209 1.791 4 4 4s4-1.791 4-4v-1z"
}), React.createElement("path", {
  d: "m20 24h-8c-.552 0-1-.448-1-1s.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1z"
}), React.createElement("path", {
  d: "m40 24h-8c-.552 0-1-.448-1-1s.448-1 1-1h8c.552 0 1 .448 1 1s-.448 1-1 1z"
})));

var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 60 60",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy.61e8c1d0.svg";
export { ForwardRef as ReactComponent };